var checked = false

export default {
    checked
}


// WEBPACK FOOTER //
// ./src/pages/advise/store.js